import { openSnackbarError } from 'store/snackbarSlice';

const showSnackbarError = (message, errorStack) => {
  if (errorStack) {
    console.error(errorStack);
  }

  return message ? openSnackbarError(message) : null;
};

export default showSnackbarError;
